import React, { useContext } from 'react';
import Button from 'components/buttons/Button';
import { setSearchDialogActive } from 'contexts/AppActions';
import useUser from 'hooks/useUser';
import { useQuery } from 'react-query';
import { fetchUserPoiMedia } from 'data/fetchers';
import AppContext from 'contexts/AppContext';
import PoiCard from 'components/cards/poi/PoiCard';

const MyPhotos = () => {
    const { user } = useUser();

    const { data: userPoiMedia } = useQuery('myPoiMedia', () => fetchUserPoiMedia(), {
        enabled: !!user,
        staleTime: 1000 * 60
    });

    const { dispatch } = useContext(AppContext);

    return (
        <div>
            <h2 className="mt-4 hidden md:block">Moje naložene fotografije</h2>
            {userPoiMedia?.data?.length === 0 && (
                <div className="p-4 md:p-6 flex flex-col md:flex-row gap-4 md:gap-8 my-4 md:my-12 bg-gray-50 max-w-xl rounded-3xl">
                    <img
                        alt="Fotografije"
                        className="h-20 sm:h-28 object-contain"
                        src="/images/photos-illustration.svg"
                    />
                    <div>
                        <h3>Naloženih fotografij (še) nismo našli</h3>
                        <p className="mt-2 mb-4">
                            Fotografije lahko preprosto naložiš tako, da poiščeš izletno točko in naložiš fotografije.
                            Ne pozabi, da se fotografije prikažejo šele, ko jih pregledajo in objavijo naši uredniki.
                        </p>
                        <Button color={'secondary'} onClick={() => setSearchDialogActive(dispatch, true)}>
                            Poišči izletno točko
                        </Button>
                    </div>
                </div>
            )}
            {userPoiMedia?.data?.length > 0 && (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8 my-4 md:my-12">
                    {userPoiMedia?.data?.map((poi) => (
                        <div key={poi.id} className="relative">
                            <div className="absolute z-10 top-2 left-2 w-8 h-8 bg-white rounded-full flex items-center justify-center font-bold">
                                {poi.photos?.length}
                            </div>
                            <PoiCard
                                poiType={poi.type}
                                title={poi.name}
                                images={poi.photos?.map((p) => ({ url: p.files.conversions.medium.url }))}
                                link={`/ideja/${poi.slug}`}
                                location={`${poi.areas.find((area) => area.type.key === 'municipality')?.name}, ${
                                    poi.areas.find((area) => area.type.key === 'region')?.name
                                }`}
                            />
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default MyPhotos;
